import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import { green, grey } from "@material-ui/core/colors";
import { FONTS } from "../constants";
import { stateType } from "../state";
import { sleep } from "./Common/helpers";
import LogoName from "./Common/LogoName";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		appBar: {
			width: "100%",
			zIndex: 10000,
			backgroundColor: "#080808",
			height: "70px",
			borderBottom: "1px solid #dadce0",
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
		},
		login: { marginRight: "40px", marginTop: "25px", display: "flex" },
		dashName: {
			color: "white",
			whiteSpace: "nowrap",
			fontSize: "23px",
			marginTop: "0px",
			marginBottom: "4px",
		},
		titleWrapper: { marginTop: "15px", textAlign: "center" },
		accountInfo: {
			color: "white",
			fontSize: "10px",
			marginTop: "-5px",
		},
		saveDashButton: {
			color: "white",
			borderColor: "white",
			"&:hover": {
				color: green[300],
				borderColor: green[300],
			},
			transition: "0.2s",
		},
		saveDashButtonDisabled: {
			cursor: "default",
			color: grey[600],
			borderColor: grey[600],
			"&:hover": {
				color: grey[600],
				borderColor: grey[600],
			},
		},
	})
);

function Title({ state }: stateType) {
	const classes = useStyles();
	const email = "";
	const status = "";
	return (
		<div style={{ fontFamily: FONTS }}>
			<div className={classes.titleWrapper}>
				<div className={classes.dashName}>
					{state.saveState.dashboardName.toUpperCase()}
				</div>
				<div
					className={classes.accountInfo}
				>{`${email} ${status}`}</div>
			</div>
		</div>
	);
}

export function TopBar({ state }: stateType) {
	const classes = useStyles();

	const savable = state.saveStateModified && !state.saveState.readOnly;

	const isBusy =
		state.isTraining || state.isProcessingData || state.isAnalyzing;

	return (
		<AppBar position="fixed" className={classes.appBar} elevation={0}>
			<LogoName></LogoName>
			<Title state={state}></Title>

			<div className={classes.login}></div>
		</AppBar>
	);
}
